import api from './ApiService';

// const check = (pageName, itemId) => {
//   if (!pageName || !itemId) {
//     console.warn('Invalid lock parameters', pageName, itemId);
//     return false;
//   }

//   return true;
// };

export default {
  getLock(pageName: string, itemId: string) {
    return api.get(`/page/${pageName}/lock`, { params: { itemId } });
  },

  takeLock(pageName: string, itemId: string) {
    return api.post(`/page/${pageName}/take`, {}, { params: { itemId } });
  },

  lockPage(pageName: string, itemId: string) {
    return api.post(`/page/${pageName}/lock`, {}, { params: { itemId } });
  },

  unlockPage(pageName: string, itemId: string) {
    return api.delete(`/page/${pageName}/lock`, { params: { itemId } });
  },

  unlockMyPage(pageName: string, itemId: string) {
    return api.delete(`/page/${pageName}/mylock`, { params: { itemId } });
  },
};
